import { Text } from 'components/Text';
import { StyledTabs, StyledList, StyledTrigger, StyledContent, Fieldset, AmountInformation, AmountInforValueName, InputField, ButtondStyle, NewsletterButton, InviteFriendsHeading, SocialIcons, FriendsReffered, FriendsRefferedValue, FriendsRefferedDiv, TimeToCashOut, ShareTheRefrral, AmountInforValue, WithdrawRadioStyle, UserProfile, UserProfileImage, UserProfileDetails, UserName, UserCash, EditImageStyle, UserPayment, RadioGroup, RadioGroupRadio, RadioGroupIndicator, HeadingWithdrawAmount, HeadingWithdrawProfile } from './WithdrawStyled'
import { Button } from 'components/Button';
import Table from 'react-bootstrap/Table'
import { SocialYellowImages, WithdrawTableDataContent, WithdrawTableHeadingContent } from './WithdrawContent';
import { Box, Flex } from 'components/Box';
import React from 'react';
import { ReactComponent as NewsLetterCopy } from 'assets/Buttons/NewsLetterCopy.svg';
import { ReactComponent as RadioTick } from 'assets/Icons/CheckBox/RadioTick.svg';
import { ReactComponent as EditIcon } from 'assets/Icons/CheckBox/EditIcon.svg';
import { Link } from "react-router-dom"
import GamesSelectValues from './GamesDropdown';

const WithdrawTabsAll: React.FC = () => {

    const [currentTab, setCurrentTab] = React.useState("Profile");

    return (
        <>
            <Flex justifyContent='center' alignItems='center'>

                <HeadingWithdrawAmount style={{ width: '70%' }}>
                    <HeadingWithdrawProfile>{currentTab}</HeadingWithdrawProfile>
                    <span style={{ color: '#fff' }}>Coins Score : </span>
                    <span style={{ color: '#CD63FF' }}>200k</span>
                </HeadingWithdrawAmount>

                <Box style={{ width: '20%' }}>
                    <GamesSelectValues />
                </Box>

            </Flex>

            <UserProfile>

                <UserProfileImage>
                    <Text>AZ</Text>
                </UserProfileImage>

                <UserProfileDetails>
                    <UserName>Aleena Zaheer</UserName>
                    <UserCash>500 BTC</UserCash>

                    <EditImageStyle>
                        <UserPayment>Payout in BTC</UserPayment>
                        <Link to='./tokenwithdraw' >
                            <EditIcon />
                        </Link>
                    </EditImageStyle>

                </UserProfileDetails>

            </UserProfile>

            <StyledTabs value={currentTab} onValueChange={setCurrentTab}>

                <StyledList>
                    <StyledTrigger value="Withdraw">Withdraw</StyledTrigger>
                    <StyledTrigger value="History">History</StyledTrigger>
                    <StyledTrigger value="Invite Friends">Invite Friends</StyledTrigger>
                </StyledList>

                <StyledContent value="Withdraw">

                    <Box style={{ margin: "30px 0 10px 0px" }}>
                        <AmountInformation>
                            <AmountInforValueName fontSize='16px'>Value</AmountInforValueName>
                            <AmountInforValue>0.0012345 BTC</AmountInforValue>
                        </AmountInformation>
                    </Box>

                    <form>
                        <RadioGroup>
                            <Flex justifyContent='center' margin='20px 0px 30px 0px'>
                                <WithdrawRadioStyle>
                                    <RadioGroupRadio value='abc' id='r1'>
                                        <RadioGroupIndicator>
                                            <RadioTick />
                                        </RadioGroupIndicator>
                                    </RadioGroupRadio>
                                    <Text> Coinbase</Text>
                                </WithdrawRadioStyle>

                                <WithdrawRadioStyle>
                                    <RadioGroupRadio value='xyz' id='r2'>
                                        <RadioGroupIndicator>
                                            <RadioTick />
                                        </RadioGroupIndicator>
                                    </RadioGroupRadio>
                                    <Text> Binance P2P</Text>
                                </WithdrawRadioStyle>
                            </Flex>
                        </RadioGroup>
                    </form>

                    <TimeToCashOut>
                        <Text>Time to cash out!</Text>
                        <Text className='mt-3'>This is the wallet email  address that you are cashing out to.</Text>
                    </TimeToCashOut>

                    <Fieldset>

                        <InputField>
                            <label>Email</label>
                            <input type="email" className="form-control" name="email" />
                        </InputField>

                        <ButtondStyle>
                            <Button type="submit">Cashout</Button>
                        </ButtondStyle>

                    </Fieldset>

                </StyledContent>

                <StyledContent value="History">
                    <Table striped responsive="sm">
                        <thead>
                            {
                                WithdrawTableHeadingContent.map((WithdrawTableHeadingContent) => (
                                    <tr key={WithdrawTableHeadingContent.id}>
                                        <th>{WithdrawTableHeadingContent.tr_Number}</th>
                                        <th>{WithdrawTableHeadingContent.tr_Date}</th>
                                        <th>{WithdrawTableHeadingContent.tr_Id}</th>
                                        <th>{WithdrawTableHeadingContent.tr_To}</th>
                                        <th>{WithdrawTableHeadingContent.tr_Amount}</th>
                                        <th>{WithdrawTableHeadingContent.tr_Hash}</th>
                                        <th>{WithdrawTableHeadingContent.tr_Status}</th>
                                    </tr>
                                ))
                            }
                        </thead>
                        <tbody>
                            {
                                WithdrawTableDataContent.map((WithdrawTableDataContent) => (
                                    <tr key={WithdrawTableDataContent.id}>
                                        <td>{WithdrawTableDataContent.td_Number}</td>
                                        <td>{WithdrawTableDataContent.td_Date}</td>
                                        <td>{WithdrawTableDataContent.td_Id}</td>
                                        <td>{WithdrawTableDataContent.td_To}</td>
                                        <td>{WithdrawTableDataContent.td_Amount}</td>
                                        <td>{WithdrawTableDataContent.td_Hash}</td>
                                        <td>{WithdrawTableDataContent.td_Status}</td>
                                    </tr>
                                ))
                            }
                        </tbody>
                    </Table>

                </StyledContent>

                <StyledContent value="Invite Friends">
                    <InviteFriendsHeading>Invite Your Friends!</InviteFriendsHeading>
                    <ShareTheRefrral>
                        Share the following referral link with your friends. Once they signup,
                        you’ll get 25% of the BTC they earn from playing - for ever!
                    </ShareTheRefrral>

                    <NewsletterButton>
                        <input type="email" className="form-control" name='email' />
                        <Button>
                            <NewsLetterCopy style={{ position: "absolute" }} />
                        </Button>
                    </NewsletterButton>

                    <FriendsRefferedDiv>
                        <FriendsReffered>Friend Refered:</FriendsReffered>
                        <FriendsRefferedValue>0</FriendsRefferedValue>
                    </FriendsRefferedDiv>

                    <SocialIcons>
                        <Text>Share on</Text>
                        {
                            SocialYellowImages.map((SocialYellowImages) => (
                                <a href={SocialYellowImages.url} key={SocialYellowImages.id} target="_blank" rel="noreferrer">
                                    <SocialYellowImages.Icon />
                                </a>
                            ))
                        }
                    </SocialIcons>

                </StyledContent>
            </StyledTabs >
        </>
    )
};

export default WithdrawTabsAll;